module.exports = __webpack_public_path__ + "img/left_03.ad8df614.png";